import { render, staticRenderFns } from "./MetricCreate.vue?vue&type=template&id=02508787"
import script from "./MetricCreate.vue?vue&type=script&lang=js"
export * from "./MetricCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports